import type { RcmBaselineLifecycleState } from './types';

export const RC_WORDMARK =
  'linear-gradient(95deg,#E2574C 0%,#E8913C 26%,#DCA93F 48%,#5DA06B 72%,#3E8E7E 100%)';

export const PB_PRACTICE = {
  name: 'Smile Bright Dental',
  contractSigned: 'Apr 22, 2026',
  pmsConnected: 'Apr 23, 2026',
  analysisCompleted: 'Apr 24, 2026',
  launchDate: 'May 8, 2026',
  daysToLaunch: 7,
};

export const PB_LIFECYCLE: Record<
  RcmBaselineLifecycleState,
  {
    key: RcmBaselineLifecycleState;
    label: string;
    bannerVariant?: string;
    monthNumber?: number;
    daysSinceLaunch?: number;
  }
> = {
  pre_launch: { key: 'pre_launch', label: 'Pre-launch · READY', bannerVariant: 'pre_launch_ready' },
  month_3: {
    key: 'month_3',
    label: 'Month 3 review',
    bannerVariant: 'month_n_review',
    monthNumber: 3,
    daysSinceLaunch: 90,
  },
  month_12: {
    key: 'month_12',
    label: 'Month 12 / Year-end',
    bannerVariant: 'year_end_review',
    monthNumber: 12,
    daysSinceLaunch: 365,
  },
  frozen: {
    key: 'frozen',
    label: 'Frozen baseline',
    bannerVariant: 'frozen',
    daysSinceLaunch: 425,
  },
};

export const BASELINE_LIFECYCLE_OPTIONS = Object.values(PB_LIFECYCLE).map((s) => ({
  key: s.key,
  label: s.label,
}));
